/* PII-GATE-SLIDESHOW v1.3 — corporate email-gate backdrop slideshow, season line, client-logo row.
   v1.3 (3 Aug 2026): gate QC — deeper scrim (.60/.84/.95), legible client logos (20/24px @.62), h2/sub text-shadow, dark slide leads, season line reworded (Friday evening Sep 11, active voice, EN+HE).
   v1.2 (3 Aug 2026): fix collision at ALL viewports. Root cause: this file sets .gate-inner{position:relative}
   for backdrop stacking, which re-parents the absolutely-pinned .gate-consent from the fixed gate to the
   content column — so it overlays the injected season/logo rows everywhere. With .pii-slides-on the consent
   is now static in flow below the logos, unconditionally. (v1.1 scoped this to compact viewports only —) — season/logo flow content grew into the bottom-pinned
   .gate-consent. Now the gate gets .pii-slides-on: consent joins the flow on compact viewports,
   gate scrolls if content exceeds the screen. Collision impossible by construction.
   Loaded ONLY by templates/page.corporate.liquid (which sits at Shopify's 256KB template limit —
   keep gate behavior/styles HERE, never inline in the template). Real product photography only. */
(function(){
  var g=document.getElementById("emailGate"); if(!g) return;
  if(g.classList.contains("dismissed")) return;
  var CDN="https://cdn.shopify.com/s/files/1/0713/0896/8128/files/";
  var IMGS=[
    CDN+"WhatsApp_Image_2026-06-14_at_15.46.29_2.jpg?v=1781624629&width=1400",
    CDN+"Honey_dish_classic.jpg?v=1781624584&width=1400",
    CDN+"Honey_dish_and_XL_Simanim_card_set_classic_65fecc2d-b6bf-4f84-abef-3612e83363c4.jpg?v=1781624703&width=1400",
    CDN+"Custom_Havdalah_candle_c385d26c-7b19-48d3-bcfe-2322d8f3fb14.jpg?v=1781624693&width=1400"
  ];
  var LOGOS=[
    "logo_cpa_be50d0c7-2a3c-4e41-a338-1fd77055c75a.png?v=1781624725",
    "logo_blevechad_0c2bbada-2fd5-4fdb-be53-46c162aae312.png?v=1781624729",
    "logo_point2point_31609e0e-eb5a-4a3e-ab9c-fcc7c39119b6.png?v=1781624714",
    "logo_projectinspire_132dc698-8b0e-44dd-b436-ae1aa6133f7a.png?v=1781624722",
    "logo_travelrepublic_official_9d114d85-825d-4561-80ea-66c23bf79715.png?v=1781624746"
  ];
  var SEASON={en:"Rosh Hashanah begins Friday evening, September 11. We’re now scheduling corporate orders.",he:"ראש השנה נכנס ביום שישי בערב, 11 בספטמבר. אנחנו כבר מתאמים הזמנות לעסקים."};
  var css=''
   +'.email-gate .gate-slides{position:absolute;inset:0;z-index:0;pointer-events:none;overflow:hidden}'
   +'.email-gate .gate-slide{position:absolute;inset:0;background-size:cover;background-position:center 30%;opacity:0;transition:opacity 1.5s ease;will-change:opacity,transform}'
   +'.email-gate .gate-slide.on{opacity:1}'
   +'.email-gate .gate-slide.zoom{animation:piiGateDrift 8.5s ease-out forwards}'
   +'@keyframes piiGateDrift{from{transform:scale(1)}to{transform:scale(1.065)}}'
   +'.email-gate .gate-dim{position:absolute;inset:0;z-index:1;background:linear-gradient(180deg,rgba(47,49,42,.60) 0%,rgba(47,49,42,.84) 46%,rgba(47,49,42,.95) 78%)}'
   +'.email-gate .gate-inner{position:relative;z-index:2}'
   +'.email-gate .gate-lang{z-index:3}'
   +'.email-gate .gate-consent{z-index:2}'
   +'.email-gate .gate-inner h2,.email-gate .gate-sub{text-shadow:0 1px 26px rgba(20,21,17,.55)}'
   +'.gate-season{margin-top:15px;font-size:.8rem;color:var(--wheat);line-height:1.5}'
   +'.gate-clients{display:flex;gap:18px;justify-content:center;align-items:center;margin:22px auto 0;min-height:22px}'
   +'.gate-clients img{height:20px;width:auto;max-width:84px;object-fit:contain;filter:brightness(0) invert(1);opacity:.62;display:block}'
   +'@media(min-width:700px){.gate-clients{gap:26px}.gate-clients img{height:24px;max-width:104px}}'
   +'@media(max-height:660px){.email-gate .gate-clients{display:none}.gate-season{margin-top:10px}}'
   +'@media(prefers-reduced-motion:reduce){.email-gate .gate-slide{transition:none}.email-gate .gate-slide.zoom{animation:none}}'
   +'.email-gate.pii-slides-on{align-items:flex-start;overflow-y:auto}'
   +'.email-gate.pii-slides-on .gate-inner{margin:auto}'
   +'.email-gate.pii-slides-on .gate-consent{position:static;left:auto;right:auto;bottom:auto;margin:16px auto 0;padding-left:0;padding-right:0;max-width:400px}';
  g.classList.add("pii-slides-on");
  var st=document.createElement("style"); st.textContent=css; document.head.appendChild(st);

  var box=document.createElement("div"); box.className="gate-slides"; box.id="gateSlides"; box.setAttribute("aria-hidden","true");
  var l0=document.createElement("div"); l0.className="gate-slide";
  var l1=document.createElement("div"); l1.className="gate-slide";
  box.appendChild(l0); box.appendChild(l1);
  var dim=document.createElement("div"); dim.className="gate-dim"; dim.setAttribute("aria-hidden","true");
  g.insertBefore(box, g.firstChild);
  g.insertBefore(dim, box.nextSibling);

  var msg=document.getElementById("gateMsg");
  if(msg && msg.parentNode){
    var lang=(document.documentElement.lang==="he")?"he":"en";
    var season=document.createElement("p"); season.className="gate-season"; season.setAttribute("data-i18n","gateSeason");
    season.textContent=SEASON[lang];
    msg.parentNode.insertBefore(season, msg.nextSibling);
    var row=document.createElement("div"); row.className="gate-clients"; row.setAttribute("aria-hidden","true");
    for(var i=0;i<LOGOS.length;i++){ var im=document.createElement("img"); im.src=CDN+LOGOS[i]; im.alt=""; im.loading="lazy"; row.appendChild(im); }
    season.parentNode.insertBefore(row, season.nextSibling);
  }

  for(var p=0;p<IMGS.length;p++){ (new Image()).src=IMGS[p]; }
  var reduce=false; try{ reduce=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches; }catch(e){}
  var layers=[l0,l1], idx=0, flip=0, t=null;
  function show(first){
    var on=layers[flip], off=layers[1-flip];
    on.style.backgroundImage='url("'+IMGS[idx]+'")';
    on.classList.remove("zoom"); void on.offsetWidth;
    on.classList.add("on"); if(!reduce) on.classList.add("zoom");
    if(!first) off.classList.remove("on");
  }
  show(true);
  if(!reduce){
    var tick=function(){ flip=1-flip; idx=(idx+1)%IMGS.length; show(false); t=setTimeout(tick,5500); };
    t=setTimeout(tick,4000);
    try{
      var mo=new MutationObserver(function(){ if(g.classList.contains("dismissed")){ if(t) clearTimeout(t); mo.disconnect(); } });
      mo.observe(g,{attributes:true,attributeFilter:["class"]});
    }catch(e){}
  }
})();
